module.exports = __webpack_public_path__ + "ClientApp/images/content/vet_tes_masthead.png";